import "../../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import {
  Fragment,
  startTransition,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import AuthContext from "../../context/AuthContext";
import BetSlipContext from "../../context/BetSlipContext";
import { inRange, isEmpty } from "lodash";
import { useNavigate, useParams, Link } from "react-router-dom";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { io } from "socket.io-client";
import ReactPlayer from "react-player";
import secureLocalStorage from "react-secure-storage";
import obj from "../../Utils/helpers";
import jwt_decode from "jwt-decode";
import Layout from "../Layout";
import Selection from "./Selection";
import Fancy from "./Fancy";
import { Button, Form } from "react-bootstrap";
import OpenBets from "../../component/OpenBets";
import { useTranslation } from "react-i18next";
import Toss from "./Toss";
import moment from "moment";
import LiveMatchTrackerCricket from "../Score/Cricket/ScoerBoardDetail";
function MatchPage() {
  const parmas = useParams();
  const {
    user,
    profileData,
    setShowPosition,
    setSocketId,
    setRightTab,
    blockList,
    setChannel,
    setShowTv,
  } = useContext(AuthContext);
  const { t } = useTranslation();
  const {
    setBetSlipObject,
    setShowBetDialog,
    betSlipObject,
    showBetDialog,
    resetBetSlipObject,
    resetBetPosition,
    setResetBetPosition,
    betPlace,
    setLimit,
    limit,
    handelPlaceFancy,
    handelPlaceBookmaker,
  } = useContext(BetSlipContext);
  const [scrollHeight, setScrollHeight] = useState(75);
  const [tab, setTab] = useState("tv");
  const ref = useRef(null);
  const [active, setActive] = useState({ Bookmaker: true, fancy: true });
  const [mute, setMute] = useState(true);
  const [marketNew, setMarketNew] = useState([]);
  const [marketId, setMarketId] = useState([]);
  const [position, setPosition] = useState([]);
  const [runner, setRunner] = useState([]);
  const [bookmaker, setBookmaker] = useState([]);
  const [checkTvRefresh, setTvCheckRefresh] = useState(true);
  const [checkRefresh, setCheckRefresh] = useState(true);
  const [marketName, setMarketName] = useState("Match Odds");
  const [fancySportTab, setFancySportTab] = useState("fancy");
  const [runnerBackOddsOld, setRuunerBackOddsOld] = useState([]);
  const [runnerLayOddsOld, setRuunerlayOddsOld] = useState([]);
  const [tossData, setTossData] = useState([]);
  const [betFairMs, setBetFairMs] = useState(1);
  const [runnerBackOdds, setRunnerBackOdds] = useState([]);
  const [runnerLayOdds, setRunnerLayOdds] = useState([]);
  const [bookmakerBackOdds, setBookmakerBackOdds] = useState([]);
  const [fancyHeader, setFancyHeader] = useState([]);
  const [bookmakerLayOdds, setBookmakerLayOdds] = useState([]);
  const [totalMatched, setTotalMatched] = useState(0);
  const [fancyPosition, setFancyPosition] = useState([]);
  const [fancy, setFancy] = useState([]);
  const [bookmakerMs, setBookmakerMs] = useState(1);
  const [ms, setMs] = useState(0);
  const [sportsBookPosition, setSportsBookPosition] = useState([]);
  const [socketObj, setSocketObj] = useState(null);
  const [sportsBook, setSportsBook] = useState([]);
  const [detail, setDetail] = useState({});
  const getMatchDetails = async (info) => {
    if (!info) {
      document.getElementById("loading").style.display = "flex";
    }
    let userId = !isEmpty(localStorage.getItem("token"))
      ? jwt_decode(localStorage.getItem("token"))?.user?._id
      : "";
    let obj = !isEmpty(parmas?.eventType)
      ? {
          userId: userId,
          eventId: parmas?.eventId,
          marketId: parmas?.marketId,
          eventType: parmas?.eventType,
        }
      : {
          userId: userId,
          eventId: parmas?.eventId,
          marketId: parmas?.marketId,
        };
    const { status, data: response_users } = await apiGet(
      apiPath.matchDetail,
      obj
    );
    if (status === 200) {
      if (response_users?.success) {
        if (response_users?.results?.resultStatus) {
          navigate("/");
        }
        setChannel(response_users?.results?.channel);

        if (
          !isEmpty(localStorage.getItem("token")) &&
          response_users?.results?.status == "in_play" &&
          response_users?.results?.channel != "false" &&
          !response_users?.results?.eventName.includes(" SRL ")
        ) {
          setShowTv(true);
        } else {
          setShowTv(false);
        }
        if (response_users?.results?.jsonData?.length == 3) {
          setTossData(response_users?.results?.jsonData.slice(0, 2) || []);
        } else {
          setTossData(response_users?.results?.jsonData || []);
        }
        if (["horse", "greyhound"].includes(parmas?.eventType)) {
          if (response_users?.results?.marketList?.length > 0) {
            setMarketNew([response_users?.results?.marketList[0]]);
            setMarketId([parmas?.marketId]);
          }
        } else {
          if (response_users?.results?.marketList?.length > 0) {
            let matchList = reorderMarkets(response_users?.results?.marketList);
            let id = matchList?.map((res) => {
              return res?.marketId;
            });
            setMarketNew(matchList || []);
            setMarketId(id);
          } else if (response_users?.results?.jsonData?.length > 0) {
            let json = {
              market: "Match Odds",
              marketId: response_users?.results?.marketId,
              jsonData: response_users?.results?.jsonData,
            };
            setMarketNew(json || []);
            setMarketId([response_users?.results?.marketId]);
          }
        }

        if (info !== "fav") {
          setFancySportTab((prev) => {
            if (info) {
              return prev;
            } else {
              if (response_users?.results?.eventType == 4) {
                return "fancy";
              } else {
                return "sport";
              }
            }
          });
        }
        setDetail(response_users?.results);
        if (response_users?.results?.jsonBookmakerData?.length > 0) {
          setBookmaker(
            response_users?.results?.jsonBookmakerData?.map((res) => {
              let id = response_users?.results?.jsonData?.find((item) => {
                return (
                  item?.RunnerName?.toLowerCase() ==
                  res?.runnerName?.toLowerCase()
                );
              });
              return {
                ...res,
                selectionID: id?.SelectionId,
                SelectionId: id?.SelectionId,
                runnerName: id?.RunnerName,
              };
            }) || []
          );
        } else {
          setBookmaker(response_users?.results?.jsonData || []);
        }
      }
    }
    if (!info) {
      document.getElementById("loading").style.display = "none";
    }
  };

  const reorderMarkets = (markets) => {
    const matchOddsIndex = markets.findIndex(
      (market) => market.market === "Match Odds"
    );

    if (matchOddsIndex > 0) {
      const matchOddsMarket = markets.splice(matchOddsIndex, 1)[0];
      markets.unshift(matchOddsMarket);
    }

    return [...markets]; // Return a new array to avoid mutating the original state
  };
  const getMatchOddsMulti = async (id) => {
    const { status, data: response_users } = await apiGet(
      apiPath.getMatchOdds +
        `?marketId=${id?.join(",")}&multi=true&eventId=${parmas?.eventId}`
    );
    if (status === 200) {
      if (response_users.success) {
        const socket_data = response_users?.results;
        if (socket_data?.length > 0) {
          setMarketNew((prev) => {
            return prev?.map((res) => {
              let tempUpdated = socket_data?.find((temp) => {
                return temp?.mi == res?.marketId;
              });
              if (tempUpdated?.mi == res?.marketId) {
                return {
                  ...res,
                  oldObj: res?.odds || {},
                  odds: {
                    mi: tempUpdated?.mi,
                    ms: tempUpdated?.ms,
                    totalMatched: tempUpdated?.totalMatched,
                    ts: tempUpdated?.ts,
                    rt: tempUpdated?.rt,
                  },
                };
              } else {
                return res;
              }
            });
          });
        }

        // let matchOdds = socket_data?.find((res) => {
        //   return res?.mi == parmas?.marketId;
        // });
        // let matchOddsNot = socket_data?.filter((res) => {
        //   return res?.mi !== parmas?.marketId;
        // });
        // if (!isEmpty(matchOdds)) {
        //   if (matchOdds.rt?.length) {
        //     const back_odds = matchOdds.rt.filter((rt) => rt.ib) || [];
        //     const lay_odds = matchOdds.rt.filter((rt) => !rt.ib) || [];
        //     setRunnerBackOdds(back_odds);
        //     setMs(matchOdds?.ms);
        //     setRunnerLayOdds(lay_odds);
        //     setTotalMatched(matchOdds?.totalMatched);
        //   }
        // }
        // if (matchOddsNot?.length > 0) {
        //   setMarketNew((prev) => {
        //     return prev?.map((res) => {
        //       let temp = socket_data?.find((temp) => {
        //         return temp?.mi == res?.marketId;
        //       });
        //       if (temp?.mi == res?.marketId) {
        //         return {
        //           ...res,
        //           oldObj: res?.odds || {},
        //           odds: {
        //             mi: temp?.mi,
        //             ms: temp?.ms,
        //             totalMatched: temp?.totalMatched,
        //             ts: temp?.ts,
        //             rt: temp?.rt,
        //           },
        //         };
        //       } else {
        //         return res;
        //       }
        //     });
        //   });
        // }
      }
    }
  };

  useEffect(() => {
    if (detail?.status == "active") {
      if (marketId?.length > 0) {
        let interval2 = setTimeout(() => {
          getMatchOddsMulti(marketId);
          if (isEmpty(parmas?.eventType)) {
            getBookmakerOdds();
          }
        }, 500);
        return () => {
          clearTimeout(interval2);
        };
      }
    } else {
      if (marketId?.length > 0) {
        let interval = setTimeout(() => {
          getMatchOddsMulti(marketId);
          if (isEmpty(parmas?.eventType)) {
            getBookmakerOdds();
          }
        }, 500);
        return () => {
          clearTimeout(interval);
        };
      }
    }
  }, [marketId, detail, parmas]);

  useEffect(() => {
    if (detail?.status == "active" && marketId?.length > 0) {
      let interval = setInterval(() => {
        getMatchOddsMulti(marketId);
      }, 3000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [marketId, detail]);

  const getFancyData = async () => {
    const { status, data: message } = await apiGet(
      apiPath.getFancyOdds + `?eventId=${parmas.eventId}`
    );
    if (status === 200) {
      if (message.success) {
        if (message?.results?.length > 0) {
          if (!isEmpty(user)) {
            setFancyPosition((prev) => {
              setFancy(
                message.results.map((res) => {
                  let obj = prev?.find(
                    (item) => item.selectionId == res.selectionId
                  );

                  return {
                    ...res,
                    odds: res,
                    fancyName: res.name,
                    position: !isEmpty(obj) ? obj?.position : "",
                    newPosition:
                      Math.abs(obj?.newPosition) > 0 ? obj?.newPosition : "",
                  };
                })
              );

              return prev;
            });
          } else {
            setFancy((prev) => {
              return message?.results?.map((res) => {
                let obj = prev?.find(
                  (item) => item.selectionId == res.selectionId
                );
                return {
                  ...res,
                  odds: res,
                  fancyName: res.name,
                  position: !isEmpty(obj) ? obj?.position : "",
                  newPosition:
                    Math.abs(obj?.newPosition) > 0 ? obj?.newPosition : "",
                };
              });
            });
          }
        }
      }
    }
  };

  const listenBetfairOdds = (event) => {
    if (event?.results?.length > 0) {
      const socket_data = event?.results;
      if (socket_data?.length > 0) {
        setMarketNew((prev) => {
          return prev?.map((res) => {
            let tempUpdated = socket_data?.find((temp) => {
              return temp?.mi == res?.marketId;
            });
            if (tempUpdated?.mi == res?.marketId) {
              return {
                ...res,
                oldObj: res?.odds || {},
                odds: {
                  mi: tempUpdated?.mi,
                  ms: tempUpdated?.ms,
                  totalMatched: tempUpdated?.totalMatched,
                  ts: tempUpdated?.ts,
                  rt: tempUpdated?.rt,
                },
              };
            } else {
              return res;
            }
          });
        });
      }
    }
  };

  const listenBookmakerData = (message) => {
    if (message?.eventId === parmas?.eventId) {
      setBookmaker((prev) => {
        return prev?.map((res) => {
          let temp = message?.results?.rt?.find((item) => {
            return item?.name === res?.RunnerName;
          });
          if (temp?.name === res?.RunnerName) {
            return {
              ...res,
              ...temp,
            };
          } else {
            return { ...res, ...temp };
          }
        });
      });
      const back_odds = message?.results?.rt?.filter((rt) => rt.ib) || [];
      const lay_odds = message?.results?.rt?.filter((rt) => !rt.ib) || [];
      setBookmakerLayOdds(lay_odds);
      setBookmakerMs(!isEmpty(message?.results?.ms) ? message?.results?.ms : 1);
      setBookmakerBackOdds(back_odds);
    }
  };
  const listenDiamondFancy = (message) => {
    if (message?.eventId === parmas?.eventId) {
      if (message?.results?.length > 0) {
        if (!isEmpty(user)) {
          setFancyPosition((prev) => {
            setFancy(
              message?.results?.map((res) => {
                let obj = prev?.find(
                  (item) => item.selectionId == res.selectionId
                );
                return {
                  ...res,
                  odds: res,
                  fancyName: res.name,
                  position: !isEmpty(obj) ? obj?.position : "",
                  newPosition:
                    Math.abs(obj?.newPosition) > 0 ? obj?.newPosition : "",
                };
              })
            );

            return prev;
          });
        } else {
          setFancy((prev) => {
            return message?.results?.map((res) => {
              let obj = prev?.find(
                (item) => item.selectionId == res.selectionId
              );
              return {
                ...res,
                odds: res,
                fancyName: res.name,
                position: !isEmpty(obj) ? obj?.position : "",
                newPosition:
                  Math.abs(obj?.newPosition) > 0 ? obj?.newPosition : "",
              };
            });
          });
        }
      }
    }
  };

  const getSocket = () => {
    if (detail?.eventId && checkRefresh) {
      if (!isEmpty(socketObj)) {
        socketObj.disconnect();
      }
      setCheckRefresh(false);
      let newSocket = "";
      let randomId = user?.user?._id ? user?.user?._id : 112233;
      if (!isEmpty(user)) {
        newSocket = io(
          `${
            detail?.socketUrl ? detail?.socketUrl : process.env.REACT_APP_SOCKET
          }?token=${randomId}&userType=front&eventId=${detail?.eventId}`,
          {
            transports: ["websocket"],
            forceNew: true,
          }
        );
      } else {
        newSocket = io(
          `${
            detail?.socketUrl ? detail?.socketUrl : process.env.REACT_APP_SOCKET
          }?user_id=${randomId}&eventId=${detail?.eventId}`,
          {
            transports: ["websocket"],
            forceNew: true,
          }
        );
      }
      setSocketId(newSocket);
      setSocketObj(newSocket);
      if (!isEmpty(user)) {
        newSocket.on("listenBetFairOdds", listenBetfairOdds);
        newSocket.on("listenBookmakerOdds", listenBookmakerData);
        if (detail?.gameType == "cricket") {
          newSocket.on("listenDiamondFancy", listenDiamondFancy);
        }
        // newSocket.on("listenPremiumFancy", listenSportBook);
        newSocket.emit("setPremiumFancy", {
          user_id: user?.user?._id ? user?.user?._id : randomId,
          eventId: parmas.eventId,
        });
      } else {
        if (detail?.gameType == "cricket") {
          newSocket.on("listenDiamondFancy", listenDiamondFancy);
        }
        newSocket.on("listenBetFairOdds", listenBetfairOdds);
        // newSocket.on("listenPremiumFancy", listenSportBook);
        newSocket.on("listenBookmakerOdds", listenBookmakerData);
      }
      newSocket.on("disconnect", function () {
        setCheckRefresh(true);
      });
      return () => newSocket.disconnect();
    }
  };

  document.addEventListener("visibilitychange", function () {
    if (!document.hidden && !checkRefresh) {
      setCheckRefresh(true);
      if (!isEmpty(socketObj)) {
        socketObj.disconnect();
      }
    } else {
      setCheckRefresh(false);
    }
  });

  const getBetPositionMulti = async (id, game) => {
    const { status, data: response_users } = await apiGet(
      apiPath.betPosition +
        `?eventId=${parmas.eventId}&type=${
          game || detail?.gameType
        }&marketId=${id?.join(",")}&multi=true`
    );
    if (status === 200) {
      if (response_users.success) {
        updatePosition(response_users?.results);
        if (response_users?.results?.betFair?.length > 0) {
          setMarketNew((current) => {
            return marketNew?.map((res) => {
              return {
                ...res,
                jsonData: res?.jsonData?.map((newObj) => {
                  let obj = response_users?.results?.betFair?.find(
                    (item) => item.selectionId == newObj?.SelectionId
                  );
                  if (!isEmpty(obj)) {
                    return {
                      ...newObj,
                      position:
                        obj.selectionId == newObj?.SelectionId
                          ? obj?.position
                          : 0,
                      newPosition: 0,
                    };
                  } else {
                    return {
                      ...newObj,
                      position: 0,
                      newPosition: 0,
                    };
                  }
                }),
              };
            });
          });
        }
      }
    }
  };
  const updatePosition = (object) => {
    setPosition(object);

    setBookmaker((current) =>
      object?.bookmaker?.length > 0
        ? current?.map((res) => {
            let obj = object?.bookmaker?.find(
              (item) => item?.selectionId == `B${res?.SelectionId}`
            );
            return {
              ...res,
              position: obj?.position ? obj?.position : 0,
              newPosition: 0,
            };
          })
        : current?.map((res) => {
            return {
              ...res,
              position: 0,
              newPosition: 0,
            };
          })
    );
    setTossData((current) =>
      object?.toss?.length > 0
        ? current?.map((res) => {
            let obj = object?.toss?.find(
              (item) => item?.selectionId == res?.SelectionId
            );
            return {
              ...res,
              position:
                obj?.selectionId == res?.SelectionId ? obj?.position : 0,
              newPosition: 0,
            };
          })
        : current?.map((res) => {
            return {
              ...res,
              position: 0,
              newPosition: 0,
            };
          })
    );
  };
  const getFancyBetPosition = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.betFancyPosition +
        `?eventId=${parmas.eventId}&type=${detail.gameType}`
    );
    if (status === 200) {
      if (response_users.success) {
        secureLocalStorage.setItem(
          "fancy",
          response_users?.results?.map((res) => {
            return {
              selectionId: res?.selectionId,
              position: res?.position,
              betRunPosition: res?.betRunPosition,
              fName: res?.fancyName,
            };
          })
        );
        updatedFancyPosition(
          response_users?.results?.map((res) => {
            return {
              selectionId: res?.selectionId,
              position: res?.position,
              betRunPosition: res?.betRunPosition,
              fName: res?.fancyName,
            };
          })
        );
      }
    }
  };
  const updatedFancyPosition = (object) => {
    setFancyPosition(object);
    setFancy((prev) => {
      return prev?.map((res) => {
        let obj = object?.find((item) => item.selectionId == res.selectionId);
        return {
          ...res,
          odds: res,
          position: !isEmpty(obj) ? obj?.position : "",
        };
      });
    });
  };
  const getSportBookBetPosition = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.betPremiumFancyPosition +
        `?eventId=${parmas.eventId}&type=${detail.gameType}`
    );
    if (status === 200) {
      if (response_users.success) {
        secureLocalStorage.setItem(
          "premiumFancy",
          response_users?.results || []
        );
        setSportsBookPosition(response_users?.results);
        setSportsBook((current) => {
          return current?.map((res) => {
            let obj = response_users?.results?.filter((item) => {
              return item?.fancyName == res?.marketName;
            });
            if (obj?.length > 0 && obj[0]?.fancyName == res?.marketName) {
              return {
                ...res,
                sportsBookSelection: res?.sportsBookSelection?.map((elem) => {
                  let temp = obj?.find(
                    (item) => elem?.id == item?.fancySelectionId
                  );
                  return {
                    ...elem,
                    position: temp?.position,
                  };
                }),
              };
            } else {
              return res;
            }
          });
        });
      }
    }
  };

  const handelBetFairPositionsMulti = (slipObj) => {
    let selectionsTemp = [...marketNew]
      ?.filter((res) => {
        return res?.marketId == slipObj?.newMarketId;
      })
      ?.map((item) => {
        return {
          ...item,
          position: item?.position || 0,
          newPosition: item?.newPosition || 0,
        };
      });
    let newArray = selectionsTemp[0]?.jsonData;
    if (betSlipObject?.bidPrice > 0) {
      if (slipObj?.object?.ib) {
        let backProfit = Number(
          Number(betSlipObject.odds - 1) * Number(betSlipObject?.bidPrice)
        );
        let backLoss = Number(betSlipObject?.bidPrice);
        if (Math.abs(newArray[0]?.position) > 0) {
          newArray = newArray?.map((rl) => {
            if (rl.SelectionId == slipObj?.object?.ri) {
              return {
                ...rl,
                newPosition: Number(rl.position) + backProfit,
              };
            } else {
              return {
                ...rl,
                newPosition: Number(rl.position) - backLoss,
              };
            }
          });
        } else {
          newArray = newArray?.map((rl) => {
            if (rl.SelectionId == slipObj?.object?.ri) {
              return {
                ...rl,
                newPosition: Number(backProfit),
              };
            } else {
              return {
                ...rl,
                newPosition: -Number(backLoss),
              };
            }
          });
        }
      } else {
        let backProfit = Number(betSlipObject?.bidPrice);
        let backLoss =
          Number(betSlipObject.odds - 1) * Number(betSlipObject?.bidPrice);
        if (Math.abs(newArray[0]?.position) > 0) {
          newArray = newArray?.map((rl) => {
            if (rl.SelectionId == slipObj?.object?.ri) {
              return {
                ...rl,
                newPosition: Number(rl.position) - backLoss,
              };
            } else {
              return {
                ...rl,
                newPosition: Number(rl.position) + backProfit,
              };
            }
          });
        } else {
          newArray = newArray?.map((rl) => {
            if (rl.SelectionId == slipObj?.object?.ri) {
              return {
                ...rl,
                newPosition: -Number(backLoss),
              };
            } else {
              return {
                ...rl,
                newPosition: Number(backProfit),
              };
            }
          });
        }
      }
    }
    setMarketNew((prev) => {
      return prev?.map((res) => {
        if (res?.marketId == slipObj?.newMarketId) {
          return { ...res, jsonData: newArray };
        } else {
          return res;
        }
      });
    });
  };
  const handelBookmakerPositions = (slipObj) => {
    let selectionsTemp = [...bookmaker]?.map((res) => {
      return {
        ...res,
        position: res?.position || 0,
        newPosition: res?.newPosition || 0,
      };
    });
    if (slipObj?.bidPrice > 0) {
      if (slipObj?.object.ib) {
        let backProfit = Number((slipObj?.odds / 100) * slipObj?.bidPrice);
        let backLoss = Number(slipObj?.bidPrice);
        if (Math.abs(selectionsTemp[0]?.position) > 0) {
          setBookmaker(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.SelectionId) {
                return {
                  ...rl,
                  newPosition: Number(rl.position) + Number(backProfit),
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(rl.position) - Number(backLoss),
                };
              }
            })
          );
        } else {
          let backProfit = Number((slipObj?.odds / 100) * slipObj?.bidPrice);
          let backLoss = Number(slipObj?.bidPrice);

          setBookmaker(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.SelectionId) {
                return {
                  ...rl,
                  newPosition: Number(backProfit),
                };
              } else {
                return {
                  ...rl,
                  newPosition: -Number(backLoss),
                };
              }
            })
          );
        }
      } else {
        if (Math.abs(selectionsTemp[0]?.position) > 0) {
          let backProfit = Number(slipObj?.bidPrice);
          let backLoss = Number((slipObj?.odds / 100) * slipObj?.bidPrice);

          setBookmaker(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.SelectionId) {
                return {
                  ...rl,
                  newPosition: Number(rl.position) - Number(backLoss),
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(rl.position) + Number(backProfit),
                };
              }
            })
          );
        } else {
          let backProfit = Number(slipObj?.bidPrice);
          let backLoss = Number((slipObj?.odds / 100) * slipObj?.bidPrice);
          setBookmaker(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.SelectionId) {
                return {
                  ...rl,
                  newPosition: -Number(backLoss),
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(backProfit),
                };
              }
            })
          );
        }
      }
    }
  };
  const handelTossPosition = (slipObj) => {
    if (betSlipObject?.bidPrice > 0) {
      let selectionsTemp = [...tossData].map((res) => {
        return {
          ...res,
          newPosition: res?.newPosition || 0,
          position: res?.position || 0,
        };
      });
      let current = selectionsTemp.find((rl) => {
        return rl?.SelectionId === slipObj?.object?.SelectionId;
      });
      let other = selectionsTemp.find((rl) => {
        return rl?.SelectionId !== slipObj?.object?.SelectionId;
      });
      if (Math.abs(current?.position) > 0 || Math.abs(other?.position) > 0) {
        let backProfit = Number(
          (betSlipObject?.odds / 100) * betSlipObject?.bidPrice
        );
        let backLoss = betSlipObject?.bidPrice;
        current.newPosition = Number(current?.position) + Number(backProfit);
        other.newPosition = Number(other?.position) - Number(backLoss);
        const result = selectionsTemp.map((data) => {
          if (data?.SelectionId == current?.SelectionId) {
            data.newPosition = current?.newPosition
              ? parseFloat(current?.newPosition)
              : 0;
          }
          if (data?.SelectionId == other?.SelectionId) {
            data.newPosition = other?.newPosition
              ? parseFloat(other?.newPosition)
              : 0;
          }
          return data;
        });
        setTossData(result);
      } else {
        let backProfit = Number(
          (betSlipObject?.odds / 100) * betSlipObject?.bidPrice
        );
        let backLoss = -Number(betSlipObject?.bidPrice);
        const result = selectionsTemp.map((data) => {
          if (data?.SelectionId == current?.SelectionId) {
            data.newPosition = backProfit ? parseFloat(backProfit) : 0;
          }
          if (data?.SelectionId == other?.SelectionId) {
            data.newPosition = backLoss ? parseFloat(backLoss) : 0;
          }
          return data;
        });
        setTossData(result);
      }
    }
  };
  const handelBetFairPositions = (slipObj) => {
    let selectionsTemp = [...runner];
    if (betSlipObject?.bidPrice > 0) {
      if (slipObj?.object?.ib) {
        let backProfit = Number(
          Number(betSlipObject.odds - 1) * Number(betSlipObject?.bidPrice)
        );
        let backLoss = Number(betSlipObject?.bidPrice);
        if (Math.abs(selectionsTemp[0]?.position) > 0) {
          setRunner(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.ri) {
                return {
                  ...rl,
                  newPosition: Number(rl.position) + backProfit,
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(rl.position) - backLoss,
                };
              }
            })
          );
        } else {
          setRunner(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.ri) {
                return {
                  ...rl,
                  newPosition: Number(backProfit),
                };
              } else {
                return {
                  ...rl,
                  newPosition: -Number(backLoss),
                };
              }
            })
          );
        }
      } else {
        let backProfit = Number(betSlipObject?.bidPrice);
        let backLoss =
          Number(betSlipObject.odds - 1) * Number(betSlipObject?.bidPrice);
        if (Math.abs(selectionsTemp[0]?.position) > 0) {
          setRunner(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.ri) {
                return {
                  ...rl,
                  newPosition: Number(rl.position) - backLoss,
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(rl.position) + backProfit,
                };
              }
            })
          );
        } else {
          setRunner(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.ri) {
                return {
                  ...rl,
                  newPosition: -Number(backLoss),
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(backProfit),
                };
              }
            })
          );
        }
      }
    }
  };
  const resetPosition = (type) => {
    if (type == "betFair") {
      setRunner((current) =>
        current.map((res) => {
          return {
            ...res,
            position: Math.abs(res?.position) > 0 ? res?.position : 0,
            newPosition: 0,
          };
        })
      );
    } else if (type == "bookmaker") {
      setBookmaker((current) =>
        current?.map((res) => {
          return {
            ...res,
            position: Math.abs(res?.position) > 0 ? res?.position : 0,
            newPosition: 0,
          };
        })
      );
    } else if (type == "multi") {
      setMarketNew((current) =>
        current?.map((res) => {
          return {
            ...res,
            jsonData: res?.jsonData?.map((newObj) => {
              return {
                ...newObj,
                position: Math.abs(newObj?.position) > 0 ? newObj?.position : 0,
                newPosition: 0,
              };
            }),
          };
        })
      );
    } else if (type == "toss") {
      setTossData(
        tossData?.map((res) => {
          return {
            ...res,
            position: res?.newPosition,
            newPosition: 0,
          };
        })
      );
    }
    setResetBetPosition(false);
    resetBetSlipObject();
  };

  useEffect(() => {
    if (checkRefresh && detail?.eventId) {
      getSocket();
    }
  }, [checkRefresh, detail]);

  useEffect(() => {
    if (resetBetPosition) {
      resetPosition(betSlipObject?.playType);
    }
  }, [resetBetPosition]);

  useEffect(() => {
    if (showBetDialog) {
      if (!isEmpty(betSlipObject)) {
        if (betSlipObject?.playType == "betFair") {
          handelBetFairPositions(betSlipObject);
        } else if (betSlipObject?.playType == "multi") {
          handelBetFairPositionsMulti(betSlipObject);
        } else if (betSlipObject?.playType == "bookmaker") {
          handelBookmakerPositions(betSlipObject);
        } else if (betSlipObject?.playType == "toss") {
          handelTossPosition(betSlipObject);
        }
      }
    }
  }, [betSlipObject, showBetDialog]);

  useEffect(() => {
    if (betPlace?.isPlaced && betPlace?.type == "matched") {
      if (betPlace?.betType == "fancy") {
        getFancyBetPosition();
      } else if (betPlace?.betType == "sportBook") {
        getSportBookBetPosition();
      } else {
        getBetPositionMulti(marketId);
      }
    } else if (betPlace?.isPlaced && betPlace?.type == "error") {
      resetPosition(betPlace?.betType);
    }
  }, [betPlace, marketId]);

  useEffect(() => {
    let interval = setInterval(() => {
      getSocket();
    }, 900000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    getMatchDetails();
    if (isEmpty(parmas?.eventType)) {
      getFancyData();
    }
  }, [parmas]);

  useEffect(() => {
    let interval = setInterval(() => {
      if (!showBetDialog) {
        getMatchDetails(true);
        if (isEmpty(parmas?.eventType)) {
          getFancyData();
        }
      }
    }, 60000);
    return () => {
      clearInterval(interval);
    };
  }, [parmas, showBetDialog]);

  useEffect(() => {
    if (!isEmpty(user)) {
      if (!isEmpty(detail)) {
        startTransition(() => {
          getBetPositionMulti(marketId);
          if (isEmpty(parmas?.eventType)) {
            getFancyBetPosition();
          }
        });
      }
    }
  }, [detail, marketId, parmas]);
  const navigate = useNavigate();

  useEffect(() => {
    let header = document.getElementById("header")
      ? Number(document.getElementById("header")?.offsetHeight) + 2
      : 0;
    setScrollHeight(header);
  }, []);

  const getBookmakerOdds = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.bookmakerOdds + `?eventId=${parmas?.eventId}`
    );
    if (status === 200) {
      if (response_users.success) {
        const message = response_users?.results;

        if (message.eventId === parmas?.eventId) {
          const back_odds = message?.rt?.filter((rt) => rt.ib) || [];
          const lay_odds = message?.rt?.filter((rt) => !rt.ib) || [];
          setBookmakerLayOdds(lay_odds);
          setBookmakerMs(!isEmpty(message?.ms) ? message?.ms : 1);
          setBookmakerBackOdds(back_odds);
        }
      }
    }
  };
  const RenderBookmaker = () => {
    return (
      bookmaker?.length > 0 &&
      detail?.hasBookmaker &&
      detail?.bookMaker == "on" &&
      detail?.gameType == "cricket" && (
        <Selection
          name="Bookmaker"
          runner={bookmaker}
          title={t("Bookmaker")}
          active={active["Bookmaker"]}
          setActive={setActive}
          scrollHeight={scrollHeight}
          marketId={parmas?.marketId}
          backOdds={detail?.bookMaker == "on" ? bookmakerBackOdds : []}
          layOdds={detail?.bookMaker == "on" ? bookmakerLayOdds : []}
          oldBack={detail?.bookMaker == "on" ? [] : []}
          oldLay={detail?.bookMaker == "on" ? [] : []}
          detail={detail}
          ms={detail?.bookMaker == "on" ? bookmakerMs : 3}
          position={position?.bookmaker?.length > 0 ? position?.bookmaker : []}
          profileData={
            detail?.matchSetting?.length > 0
              ? {
                  ...detail,
                  arrayCheck: "details",
                  profile: profileData,
                }
              : {
                  ...profileData,
                  arrayCheck: "profile",
                  profile: profileData,
                }
          }
          typeGame="bookmaker"
          totalMatched={0}
          marketName={"Bookmaker"}
          setShowBetDialog={setShowBetDialog}
          setLimit={setLimit}
          setBetSlipObject={setBetSlipObject}
          user={user}
          setRightTab={setRightTab}
        />
      )
    );
  };

  let tabPosition = {
    cricket: "bottom",
    tennis: "top",
    soccer: "bottom",
  };
 const displayScore = () => {
    return (
      <iframe
        className="responsive-iframe w-100"
        style={{
          overflowX: "hidden",
          overflow: "hidden",
          // height: "510px",
          height: detail?.screenScore === "full" ? "270px" : "141px",
          backgroundColor: "#000000",
        }}
        id="scoreId"
        src={detail?.scoreURL}
      ></iframe>
    );
  };

  return (
    <Layout>
      {detail?.match == "on" && (
        <Col md={9}>
          <div
            data-aos="zoom-in-up"
            className="BlackBox mb-2"
            style={{ borderRadius: "0" }}
          >
            <div
              style={{
                color: "white",
                padding: "5px 10px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ fontSize: "18px" }}>{detail?.eventName}</div>
              <p className="Date mb-0" style={{ fontWeight: "600" }}>
                {" "}
                {obj.matchDateTimeDetail(
                  detail?.market == "Win"
                    ? detail?.MarketTime
                    : detail?.eventDateTime
                )}
              </p>
            </div>
            {!["Winner", "Win"].includes(detail?.market) &&
              detail?.status == "in_play" && (
                <div className="B-body">
                  {!isEmpty(detail?.scoreURL) && displayScore()}
                </div>
              )}
          </div>
          <div className="mb-2">
            {marketNew?.length > 0 &&
              marketNew?.map((res, index) => {
                return (
                  <Fragment>
                    <Selection
                      runner={res?.jsonData}
                      name={res?.market}
                      active={active[res?.market]}
                      setActive={setActive}
                      totalMatched={
                        !isEmpty(res?.odds) ? res?.odds?.totalMatched : 0
                      }
                      title={res?.market}
                      marketId={res?.marketId}
                      scrollHeight={scrollHeight}
                      backOdds={
                        detail?.matchOdds == "on"
                          ? !isEmpty(res?.odds) && res?.odds?.rt?.length > 0
                            ? res?.odds?.rt?.filter((rt) => rt.ib)
                            : []
                          : []
                      }
                      layOdds={
                        detail?.matchOdds == "on"
                          ? !isEmpty(res?.odds) && res?.odds?.rt?.length > 0
                            ? res?.odds?.rt?.filter((rt) => !rt.ib)
                            : []
                          : []
                      }
                      oldBack={
                        detail?.matchOdds == "on"
                          ? !isEmpty(res?.oldObj) && res?.oldObj?.rt?.length > 0
                            ? res?.oldObj?.rt?.filter((rt) => rt.ib)
                            : []
                          : []
                      }
                      oldLay={
                        detail?.matchOdds == "on"
                          ? !isEmpty(res?.oldObj) && res?.oldObj?.rt?.length > 0
                            ? res?.oldObj?.rt?.filter((rt) => !rt.ib)
                            : []
                          : []
                      }
                      detail={detail}
                      ms={!isEmpty(res?.odds) ? res?.odds?.ms : 3}
                      position={
                        position?.betFair?.length > 0 ? position?.betFair : []
                      }
                      profileData={
                        detail?.matchSetting?.length > 0
                          ? {
                              ...detail,
                              arrayCheck: "details",
                              profile: profileData,
                            }
                          : {
                              ...profileData,
                              arrayCheck: "profile",
                              profile: profileData,
                            }
                      }
                      typeGame="multi"
                      marketName={res?.market}
                      setShowBetDialog={setShowBetDialog}
                      setLimit={setLimit}
                      setBetSlipObject={setBetSlipObject}
                      user={user}
                      setRightTab={setRightTab}
                    />
                    {index == 0 && marketNew?.length >= 1 && RenderBookmaker()}
                  </Fragment>
                );
              })}
            {marketNew?.length == 0 && RenderBookmaker()}{" "}


            
            {!["Winner", "Win"].includes(detail?.market) &&
              moment(new Date()).isBefore(
                moment(detail.eventDateTime).subtract(45, "m").toDate()
              ) &&
              detail?.isTossEnable &&
              !isEmpty(
                marketNew?.find((res) => {
                  return res?.market == "Match Odds";
                })
              ) &&
              detail?.gameType == "cricket" && (
                <Toss
                  runner={tossData}
                  name="toss"
                  title={"Toss"}
                  scrollHeight={scrollHeight}
                  marketId={parmas?.marketId}
                  // BetSlip={BetSlip}
                  detail={detail}
                  position={position?.toss?.length > 0 ? position?.toss : []}
                  profileData={
                    detail?.matchSetting?.length > 0
                      ? { ...detail, arrayCheck: "details" }
                      : { ...profileData, arrayCheck: "profile" }
                  }
                  setShowBetDialog={setShowBetDialog}
                  setLimit={setLimit}
                  setBetSlipObject={setBetSlipObject}
                  user={user}
                  setRightTab={setRightTab}
                />
              )}
          </div>
          {!["Winner", "Win"].includes(detail?.market) &&
            detail?.gameType == "cricket" &&
            detail?.hasFancy && (
              <div data-aos="zoom-in-up" className="mb-4">
                <Fancy
                  title={t("Fancy")}
                  data={fancy}
                  user={user}
                  detail={detail}
                  setActive={setActive}
                  active={active["fancy"]}
                  position={fancyPosition}
                  setLimit={setLimit}
                  scrollHeight={scrollHeight}
                  setShowPosition={setShowPosition}
                  profileData={
                    detail?.matchSetting?.length > 0
                      ? {
                          ...detail,
                          arrayCheck: "details",
                          profile: profileData,
                        }
                      : {
                          ...profileData,
                          arrayCheck: "profile",
                          profile: profileData,
                        }
                  }
                  setRightTab={setRightTab}
                />
              </div>
            )}
        </Col>
      )}
    </Layout>
  );
}

export default MatchPage;
const number = [25, 50, 100, 1000, 10000, 25000];
